// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import axios from './api/http'
import { apiPath, ydcPath, otherPath, appPath} from './api/service'
import Vue from 'vue'
import App from './App'
import router from './router'
import {Loading, InfiniteScroll, Icon, Input, Link, Button, Message, MessageBox, Dialog,Form, FormItem, Radio, RadioGroup, Select, Option, DatePicker, Checkbox, CheckboxGroup, Table, TableColumn, Pagination, Dropdown, DropdownItem, DropdownMenu, Tooltip, Collapse, CollapseItem} from 'element-ui'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import * as formatWan from './assets/js/formatWan'

Object.keys(formatWan).forEach(k => Vue.filter(k, formatWan[k]))
Vue.config.productionTip = false
Vue.use(Loading);
Vue.use(Icon);
Vue.use(Input);
Vue.use(Link);
Vue.use(Button);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Select);
Vue.use(Option);
Vue.use(DatePicker);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Pagination);
Vue.use(Dropdown);
Vue.use(DropdownItem);
Vue.use(DropdownMenu);
Vue.use(InfiniteScroll);
Vue.use(Dialog);
Vue.use(Tooltip);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.prototype.$message = Message;
Vue.prototype.$messageBox = MessageBox;
import vuescroll from 'vuescroll'
import 'vuescroll/dist/vuescroll.css';
Vue.use(vuescroll)
Vue.use(Viewer)
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
Vue.use(VueVideoPlayer)
Vue.directive('loadmore', {
  bind(el, binding) {
    const selectWrap = el.querySelector('.el-table__body-wrapper')
    selectWrap.addEventListener('scroll', function() {
      let sign = 30
      const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight
      if (scrollDistance <= sign) {
        binding.value()
      }
    })
  }
})
//资讯页面滚动加载
Vue.directive('loadmore2', {
  bind(el, binding) {
    // console.log(el)
    const selectWrap = el.querySelector('.__panel')
    selectWrap.addEventListener('scroll', function () {
      // let sign = 30
      const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight
      // console.log(scrollDistance);
      if (scrollDistance <= 0) {
        binding.value()
      }
    })
  }
})
Vue.prototype.axios = axios;
Vue.prototype.apiPath = apiPath;
Vue.prototype.ydcPath = ydcPath;
Vue.prototype.otherPath = otherPath;
Vue.prototype.appPath = appPath;

window.loadingStyle = {
  lock: true,
  text: '加载中',
  // spinner: 'el-icon-loading',
  background: 'rgba(0, 0, 0, 0.7)'
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js